import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';
import { SncfVoyageursLogo, FluoLogo } from './SncfVoyageursLogo';
import { CookieReopenLink } from './CookieConsent';

const API = process.env.REACT_APP_BACKEND_URL || '';
const FALLBACK_SOURCES = 'Données : SNCF Open Data • Navitia • GTFS-RT';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [footerLabels, setFooterLabels] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/footer-config`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(d => setFooterLabels(d.footer_labels ?? null))
      .catch(() => setFooterLabels(null));
  }, []);

  const lang        = (i18n.language ?? 'fr').split('-')[0];
  const sourcesText = footerLabels?.[lang] ?? FALLBACK_SOURCES;
  return (
    <footer className="bg-ter-blue-dark text-white">
      <div className="h-1.5 diag-stripes" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="inline-flex items-center gap-4 bg-white rounded-lg px-4 py-2 shadow-sm">
            <SncfVoyageursLogo height={36} />
            <span className="h-8 w-px bg-slate-200" aria-hidden="true" />
            <FluoLogo height={36} />
          </div>
          <p className="text-sm text-white/70 mt-5 max-w-md">{t('footer.text')}</p>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-wider text-white/50 font-semibold mb-3">{t('footer.nav_title')}</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-ter-yellow">{t('nav.home')}</a></li>
            <li><a href="/tableau" className="hover:text-ter-yellow">{t('nav.board')}</a></li>
            <li>
              <Link
                to="/admin"
                data-testid="footer-admin-link"
                className="inline-flex items-center gap-1.5 text-white/80 hover:text-ter-yellow"
              >
                <ShieldCheck className="w-3.5 h-3.5" />
                {t('footer.admin_link')}
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-wider text-white/50 font-semibold mb-3">{t('footer.legal_title')}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/mentions-legales" className="hover:text-ter-yellow">{t('footer.legal_terms')}</Link></li>
            <li><Link to="/politique-confidentialite" className="hover:text-ter-yellow">{t('footer.legal_privacy')}</Link></li>
            <li><Link to="/cgu" className="hover:text-ter-yellow">{t('footer.legal_cgu')}</Link></li>
            <li><CookieReopenLink /></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between flex-wrap gap-2 text-xs text-white/60">
          <span>{t('footer.copyright', { year: new Date().getFullYear() })}</span>
          <span>{sourcesText}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
